import { render, staticRenderFns } from "./ModalEditEventOrganizer.vue?vue&type=template&id=72b469f2&scoped=true"
import script from "./ModalEditEventOrganizer.vue?vue&type=script&lang=js"
export * from "./ModalEditEventOrganizer.vue?vue&type=script&lang=js"
import style0 from "./ModalEditEventOrganizer.vue?vue&type=style&index=0&id=72b469f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b469f2",
  null
  
)

export default component.exports